import type { ShopperProducts } from '@/scapi';
import type { BrandsCuratedVariant } from './brands-utils';

export type BurgerMenuStackEntry =
    | { type: 'category'; category: ShopperProducts.schemas['Category'] }
    | { type: 'brands' }
    | { type: 'brands-curated'; variant: BrandsCuratedVariant };

export function getNavigationLevelKey(stack: BurgerMenuStackEntry[]): string {
    if (stack.length === 0) {
        return 'root';
    }

    return stack
        .map((entry) => {
            if (entry.type === 'category') {
                return entry.category.id;
            }

            if (entry.type === 'brands-curated') {
                return `brands-${entry.variant}`;
            }

            return entry.type;
        })
        .join('/');
}

export function getActiveCategoryFromStack(
    stack: BurgerMenuStackEntry[]
): ShopperProducts.schemas['Category'] | undefined {
    const entry = stack.at(-1);

    return entry?.type === 'category' ? entry.category : undefined;
}
